/* Purpose: open/close the single header localization dialog without replacing
 * Shopify's form submission. Usage: loaded by mvk-locale-dialog; delegated
 * events survive Theme Editor section reloads and restore the trigger focus. */
(() => {
  if (window.mvkLocaleModalLoaded) return;
  window.mvkLocaleModalLoaded = true;
  let trigger;
  document.addEventListener('click', event => {
    const dialog = document.querySelector('[data-mvk-locale-dialog]');
    if (!dialog) return;
    const open = event.target.closest('[data-mvk-locale-open]');
    if (open) {
      trigger = open;
      if (!dialog.open) dialog.showModal();
      return;
    }
    if (event.target.closest('[data-mvk-locale-close]') || event.target === dialog) dialog.close();
  });
  document.addEventListener('close', event => {
    if (event.target.matches?.('[data-mvk-locale-dialog]')) trigger?.focus();
  }, true);
})();
